import React from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

interface CourseDateSectionProps {
  dateFields: string[];
  formik: any;
}
const CourseDateSection: React.FC<CourseDateSectionProps> = ({ dateFields, formik }) => {
  const formikValues = formik.values;
  const touchedFields = formik.touched;
  const errors = formik.errors;
  const setFieldValue = formik.setFieldValue;
  const setFieldTouched = formik.setFieldTouched;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      {dateFields.map((dateField) => (
        <Grid item xs={12} key={dateField}>
          <DateTimePicker
            // split each label on '_' and map over the array to capitalize each word, then join the array back into a string with spaces
            label={dateField
              .split('_')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ')}
            value={formikValues[dateField] ? new Date(formikValues[dateField]) : ''}
            onAccept={(newValue: any) => {
              if (newValue && !isNaN(new Date(newValue).getTime())) {
                setFieldValue(dateField, newValue.toISOString());
              }
            }}
            onChange={(newValue: any) => {
              if (newValue && !isNaN(new Date(newValue).getTime())) {
                setFieldValue(dateField, newValue.toISOString());
                setFieldTouched(dateField, true);
              }
            }}
            renderInput={(params) => <TextField {...params} aria-label={dateField} fullWidth />}
            componentsProps={{
              actionBar: {
                actions: ['today'],
              },
            }}
          />
          {touchedFields[dateField] && Boolean(errors[dateField]) && (
            <Typography variant='caption' color='error'>
              {errors[dateField]}
            </Typography>
          )}
        </Grid>
      ))}
    </LocalizationProvider>
  );
};
export default CourseDateSection;
